import cx from 'classnames';
import { debounce } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { icons } from '../../assets';
import styles from './VideoPreviewModal.module.scss';
const { CloseIconSmall, ExpandIcon, DragIcon } = icons;

const initialPosition = { x: 0, y: 0 };

export default function VideoPreviewModal({ setPreviewVideoDetails, data }) {
  const isCentered = true;
  const [position, setPosition] = useState(initialPosition);
  const positionRef = useRef(position);
  positionRef.current = position;
  const videoContainerRef = useRef(null);

  useEffect(() => {
    handleSetPosition();
  }, [
    isCentered,
    videoContainerRef?.current?.clientWidth,
    videoContainerRef?.current?.clientHeight,
  ]);

  const handleSetPosition = () => {
    if (!videoContainerRef?.current) return;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const videoWidth = videoContainerRef?.current?.clientWidth || 0;
    const videoHeight = videoContainerRef?.current?.clientHeight || 0;
    const posX = (windowWidth - videoWidth) / 2;
    const posY = (windowHeight - videoHeight) / 2;
    setPosition(
      isCentered
        ? {
            x: posX,
            y: posY,
          }
        : initialPosition
    );
  };

  useEffect(() => {
    const listener = debounce(() => {
      if (!videoContainerRef?.current) return;
      const clientRect = videoContainerRef?.current?.getBoundingClientRect();
      if (window.innerWidth > 1220) {
        handleSetPosition();
        return;
      }
      const { top, left, right } = clientRect;
      const { x, y } = positionRef.current;
      let newX = x;
      let newY = y;
      if (left < 0) {
        newX = x + Math.abs(left);
      } else {
        const rightDiff = right - window.innerWidth;
        if (rightDiff > 0) {
          if (rightDiff > left) {
            newX = x - left;
          } else {
            newX = x - rightDiff;
          }
        }
      }
      if (top < 0) {
        newY = y + Math.abs(top);
      }
      if (x !== newX || y !== newY) {
        setPosition({ x: newX, y: newY });
      }
      if (window.innerHeight < 400) {
        setPosition(initialPosition);
      }
    }, 60);
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
      listener.cancel();
    };
  }, []);

  const handleClose = () => {
    setPreviewVideoDetails(null);
    setPosition(initialPosition);
  };

  return (
    <Draggable bounds="parent" handle=".video-drag" position={position}>
      <div
        className={cx(styles.videoModal, !isCentered ? styles.small : '')}
        ref={videoContainerRef}
        style={isCentered ? { left: 0, top: 0 } : {}}>
        <div className={styles.videoModalInner}>
          <Button onClick={handleClose} className={styles.close}>
            <CloseIconSmall />
          </Button>
          <Video srcId={data?.file} />
        </div>
      </div>
    </Draggable>
  );
}

const Video = ({ srcId }) => {
  if (!srcId) return null;
  return (
    <div className={styles.videoResponsive}>
      <video
        key={srcId}
        loop
        controls
        // muted
        playsInline
        autoPlay
        onContextMenu={(e) => {
          e.preventDefault();
          return false;
        }}
        style={{
          width: '100%',
          height: '100%',
          background: 'linear-gradient(174deg, #000000, #444444)',
        }}>
        <source src={srcId} />
      </video>
    </div>
  );
};
